import { Grid, hooks, SkeletonBox } from '@bitrise/bitkit';
import { Crash, TypeAttribute } from '@trace/types';
import { DateTime } from 'luxon';
import React, { FunctionComponent } from 'react';

import dataAtIds from '../../../dataAtIds.json';
import getFormattedAttributeValue from '../../../utils/getFormattedAttributeValue';
import AttributeStat from '../../AttributeStat/AttributeStat';

const { useMediaQuery } = hooks;

interface Props {
  crash?: Crash;
  isFetching: boolean;
}

const CrashAttributes: FunctionComponent<Props> = ({ crash, isFetching }) => {
  const matchQuery = useMediaQuery(['700px']);

  return (
    <Grid gap="x6" repeat={matchQuery({ '700px': 4 }) || 2} repeatWidth="1fr">
      <AttributeStat attribute="First Seen" data-trace-at-id={dataAtIds.CrashPageFirstSeen}>
        {!isFetching && !!crash ? (
          DateTime.fromISO(crash.firstSeen).toRelative()
        ) : (
          <SkeletonBox height="1.125rem" />
        )}
      </AttributeStat>

      <AttributeStat attribute="Last Seen" data-trace-at-id={dataAtIds.CrashPageLastSeen}>
        {!isFetching && !!crash ? (
          DateTime.fromISO(crash.lastSeen).toRelative()
        ) : (
          <SkeletonBox height="1.125rem" />
        )}
      </AttributeStat>

      <AttributeStat
        attribute="Number of Occurrences"
        data-trace-at-id={dataAtIds.CrashPageNumberOfOccurrences}
      >
        {!isFetching && !!crash ? (
          getFormattedAttributeValue(
            'Number of Occurrences' as TypeAttribute,
            crash.occurrenceCount,
          )
        ) : (
          <SkeletonBox height="1.125rem" />
        )}
      </AttributeStat>

      <AttributeStat attribute="Users Affected" data-trace-at-id={dataAtIds.CrashPageUsersAffected}>
        {!isFetching && !!crash ? (
          getFormattedAttributeValue('Users Affected' as TypeAttribute, crash.deviceCount)
        ) : (
          <SkeletonBox height="1.125rem" />
        )}
      </AttributeStat>
    </Grid>
  );
};

export default CrashAttributes;
